import { MANUAL_ZOOM_IN_EVENT, MANUAL_ZOOM_OUT_EVENT } from './constants';
/**
 * Dispatches a manual zoom in event that is captured by the Google Map widget.
 * This will increases the map zoom level by 1 on the listener.
 * Disabling logic is on the element itself.
 */
export const manualOnZoomIn = () => {
    window.dispatchEvent(new Event(MANUAL_ZOOM_IN_EVENT));
};
/**
 * Dispatches a manual zoom out event that is captured by the Google Map widget.
 * This will decrease the map zoom level by 1 on the listener.
 * Disabling logic is on the element itself.
 */
export const manualOnZoomOut = () => {
    window.dispatchEvent(new Event(MANUAL_ZOOM_OUT_EVENT));
};
